import { usePersistedStore } from "@asurion-core/headless-chat-web";

import { useGuideStore } from "../store";
import { toSimplrTicketId } from "./simplrTicketId";

export function getRoomId(sessionId: string, omitExternalTicketId = false) {
    const { errorStateSessionId } = useGuideStore.getState().getGuideSession(sessionId);
    const { externalTicketIdMetadataMap: roomIdsBySession, simplrChat } = usePersistedStore.getState();
    // A session started without a ticket id (restarts included) has its room only in the SDK config.
    if (omitExternalTicketId) return simplrChat.config.roomId;
    return roomIdsBySession[toSimplrTicketId(errorStateSessionId || sessionId)]?.simplrChatRoomId;
}
